<!--Title-->
<h3>{{'_General_Manage_Lobby_Text_' | translate }}</h3>

<div>
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills cc-tab">
    <li [ngbNavItem]="1" id="lobby-queue">
      <a ngbNavLink>{{'_Lobby_Lobby_Queue_Text_' | translate}}/{{staffColumnText}} {{'_General_Status_Text_' | translate}}</a>
      <ng-template ngbNavContent>
        <app-lobby-staff-status></app-lobby-staff-status>
      </ng-template>
    </li>
    <li [ngbNavItem]="2" id="appointment-queue" *ngIf="(isACLicenseEnabled$ | async)">
      <a ngbNavLink>{{'_Lobby_Appointment_Queue_Text_' | translate }}</a>
      <ng-template ngbNavContent>
        <app-appointment-status-grid></app-appointment-status-grid>
      </ng-template>
    </li>
    <li [ngbNavItem]="3" id="central-views" *ngIf="userPermissionList?.includes(47)">
      <a ngbNavLink>{{'_Lobby_Central_Views_Text_' | translate }}</a>
      <ng-template ngbNavContent>
        <app-lobby-central-views></app-lobby-central-views>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class=""></div>
</div>